import React from 'react';
import HighlightVideoPlayer from '../../helpers/HighlightVideoPlayer';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { Box, Card, Text } from 'grommet';
import { GameSummary } from './playerHooks';

interface GameSummaryCardProps extends RouteComponentProps {
  gameSummary: GameSummary;
}

const GameSummaryCard: React.FC<GameSummaryCardProps> = ({
  gameSummary,
  history,
}) => {
  if (!gameSummary) {
    return null;
  }

  return (
    <Card
      id="inner"
      style={{ display: 'inline-block' }}
      width={{ min: '240px', max: '240px' }}
      round="small"
      margin="small"
    >
      <Box height="147px">
        <HighlightVideoPlayer
          id={gameSummary._id}
          hvid={gameSummary}
          category={gameSummary.category}
          videoSrc={gameSummary.fileUrl720}
          autoplay={false}
          location="player_page"
        />
      </Box>
      <Box
        pad="small"
        onClick={() => {
          if (gameSummary.category === 'game') {
            history.push(`/game/${gameSummary.gameIdList?.[0]}`);
          } else if (gameSummary.category === 'player') {
            history.push(`/hitmatch/${gameSummary._id}`);
          }
        }}
      >
        <Text weight="bold" size="medium" truncate>
          {gameSummary.titleMain}
        </Text>
      </Box>
    </Card>
  );
};

export default withRouter(GameSummaryCard);
